import type { Paragraph, Table } from "docx";
import { downloadWordDocument } from "@/lib/documentGenerator/exportHistory";
import { createStampForCurrentUser } from "@/lib/documentGenerator/watermark";
import { body, buildDocument, h1, signatureBlock } from "@/lib/documentGenerator/docTheme";
import { SAM_ROUTINE_SECTIONS, SAM_ROUTINE_STATUS_LABELS } from "@/lib/basProcess/samRoutine";
import { documentFooter } from "@/lib/documentGenerator/documentFooter";

export const generateSamRoutineWordDocument = async (
  routine: { name: string; version: string; status: string; sections: Record<string, string> },
  projectName?: string
) => {
  const documentName = routine.name || "Rutin – Systematiskt arbetsmiljöarbete";
  const stamp = await createStampForCurrentUser({
    docNumber: "01",
    documentName,
    projectName,
  });

  const children: (Paragraph | Table)[] = SAM_ROUTINE_SECTIONS.flatMap((s, i) => [
    h1(`${i + 1}. ${s.title}`),
    body(routine.sections?.[s.key] ?? ""),
  ]);
  const footer = await documentFooter({ docNumber: "01", documentType: "sam_rutin" });


  const doc = buildDocument({
    meta: {
      review: footer.review,
      docNumber: "01",
      documentName,
      projectName,
      version: routine.version || "1.0",
      status:
        SAM_ROUTINE_STATUS_LABELS[routine.status as keyof typeof SAM_ROUTINE_STATUS_LABELS] ||
        routine.status,
    },
    stamp,
    children: [...children, ...footer.children],
  });

  await downloadWordDocument(
    doc,
    `Dok01_Rutin_SAM_${(projectName || "projekt").replace(/[^\w-]+/g, "_")}.docx`,
    {
      documentType: "sam_rutin",
      docNumber: "01",
      documentName,
      snapshot: routine,
      stamp,
    }
  );
};
